<ng-container *ngIf="virtualUrl">
  <app-imagepdfviewer [src]="virtualUrl" [width]="getWidth()" [height]="getHeight()"></app-imagepdfviewer>
</ng-container>
